import React from 'react';
import Amazonlogo from '../images/Amazon-India-Logo-PNG-HD.png';
import Address from '../images/map-marker-alt-solid.svg';
import Searchicon from '../images/search-solid.svg';
import Cart from '../images/shopping-cart-solid.svg';
import '../css/header.css';
import {Link} from 'react-router-dom';

function Header(){
    return(
        <header>
        <div className="header" id="main-header">
            <div className="header-container">
                <div className="header_logo">
                    <div className="header_mainlogo">
                        <Link to="/"><img src={Amazonlogo} alt="Amazonlogo" className="amazonlogo" /></Link>
                    </div>
                    <div className="header_yourlocation">
                        <p className="hello">Hello</p>
                        <span><img src={Address} alt="Address" className="address" /></span>
                        <span className="your-address">Select Your Address</span>
                    </div>
                </div>
                <div className="header_search">
                    <select className="seleteditems" title="search in">
                            <option selected="selected" value="search-alias=aps">All Categories</option>
                            <option value="search-alias=todays-deals">Deals</option>
                            <option value="search-alias=alexa-skills">Alexa Skills</option>
                            <option value="search-alias=amazon-devices">Amazon Devices</option>
                            <option value="search-alias=fashion">Amazon Fashion</option>
                            <option value="search-alias=nowstore">Amazon Fresh</option>
                            <option value="search-alias=pantry">Amazon Pantry</option>
                            <option value="search-alias=appliances">Appliances</option>
                            <option value="search-alias=mobile-apps">Apps &amp; Games</option>
                            <option value="search-alias=baby">Baby</option>
                            <option value="search-alias=beauty">Beauty</option>
                            <option value="search-alias=stripbooks">Books</option>
                            <option value="search-alias=automotive">Car &amp; Motorbike</option>
                            <option value="search-alias=apparel">Clothing &amp; Accessories</option>
                            <option value="search-alias=collectibles">Collectibles</option>
                            <option value="search-alias=computers">Computers &amp; Accessories</option>
                            <option value="search-alias=electronics">Electronics</option>
                            <option value="search-alias=furniture">Furniture</option>
                            <option value="search-alias=lawngarden">Garden &amp; Outdoors</option>
                            <option value="search-alias=gift-cards">Gift Cards</option>
                            <option value="search-alias=grocery">Grocery &amp; Gourmet Foods</option>
                            <option value="search-alias=hpc">Health &amp; Personal Care</option>
                            <option value="search-alias=kitchen">Home &amp; Kitchen</option>
                            <option value="search-alias=industrial">Industrial &amp; Scientific</option>
                            <option value="search-alias=jewelry">Jewellery</option>
                            <option value="search-alias=digital-text">Kindle Store</option>
                            <option value="search-alias=luggage">Luggage &amp; Bags</option>
                            <option value="search-alias=luxury-beauty">Luxury Beauty</option>
                            <option value="search-alias=dvd">Movies &amp; TV Shows</option>
                            <option value="search-alias=popular">Music</option>
                            <option value="search-alias=mi">Musical Instruments</option>
                            <option value="search-alias=office-products">Office Products</option>
                            <option value="search-alias=pets">Pet Supplies</option>
                            <option value="search-alias=instant-video">Prime Video</option>
                            <option value="search-alias=shoes">Shoes &amp; Handbags</option>
                            <option value="search-alias=software">Software</option>
                            <option value="search-alias=sporting">Sports, Fitness &amp; Outdoors</option>
                            <option value="search-alias=home-improvement">Tools &amp; Home Improvement</option>
                            <option value="search-alias=toys">Toys &amp; Games</option>
                            <option value="search-alias=under-ten-dollars">Under ₹500</option>
                            <option value="search-alias=videogames">Video Games</option>
                            <option value="search-alias=watches">Watches</option>
                        </select>
                   
                    <input type="text"
                      placeholder="Search..."
                      className="searchbox"
                    />
                    <div className="search_icon">
                        <img src={Searchicon} alt="searchicon" className="searchicon" />
                    </div>
                </div>
                <div className="header_nav">
                     <nav>
                         <ul>
                             <li>Country</li>
                             <li><span>Hello, sign in</span>Account&List</li>
                             <li><span>Returns</span>&Order</li>
                             <li><Link to="/checkout"><span className="cart"><img src={Cart} alt="cart" /></span><p>0</p></Link></li>
                         </ul>
                     </nav>
                </div>
            </div>
        </div>
     </header>
    )
}

export default Header;